// extracted by mini-css-extract-plugin
module.exports = {"media-galleries":"mhISTP","media-galleries__button":"_3kUrIl","media-galleries__button--disabled":"_3uOtsd","media-galleries__button-image":"uTk8in"};